import { FC, useState } from "react"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, TabsContent } from "../../components/ui"
import { Categories } from "../inventory/categories/categories"
import { Units } from "../inventory/units/units"

type StorageSettingsPropsType = {}

const StorageSettingsTab: FC<StorageSettingsPropsType> = () => {

  return (
    <TabsContent value="storage_settings">
      <div className="w-full flex flex-col rounded-sm w-1/3 h-fit overflow-y-scroll p-2">

        <Accordion type="multiple" defaultValue={["units", "categories"]}>

          <AccordionItem value="units">
            <AccordionTrigger>Storage Units</AccordionTrigger>
            <AccordionContent><Units /></AccordionContent>
          </AccordionItem>

          <AccordionItem value="categories">
            <AccordionTrigger>Categories</AccordionTrigger>
            <AccordionContent><Categories /></AccordionContent>
          </AccordionItem>

        </Accordion>

      </div>
    </TabsContent>
  )
}

export default StorageSettingsTab
